export default defineAppConfig({
  defaultCountry: 'de',
  defaultLang: 'de',
  customer: 'wilo',
  titleSeparator: ' | ',
  companyDesc: 'Amirada',
  useLocalStorage: true,
  useShoppingCartCountry: true, // Shopping cart for each country
  // The embedding parameter by which the CMS marks a caller as a bot ('true'), e.g. 'embparam6'. Set,
  // the SSR sends `x-client-bot: 1` with its pfinder calls for such a caller, and the server's bot
  // lane can turn bots away before people (loop-watch, LOOPWATCH_BOT_SHED). Empty = no bot flag.
  botEmbParam: '',
  /*
   * Carts that belong to the TAB, not to the origin: never written to local storage, never replaced
   * from it. They exist in the tab that is working on them and in whatever store they are saved to —
   * for the price list, its project on the server.
   *
   * Every other cart is shared across tabs on purpose: put something in the cart in one tab and it
   * appears in the other. A cart listed here has no use for that — its content is created inside the
   * cart itself, not contributed from a second tab — and it cannot survive it: two tabs writing the
   * same key means the last writer wins, so one tab's work replaces the other's.
   *
   * ⚑ It takes BOTH halves, and the second is easy to miss. Not writing stops the cart from waking
   * other tabs. Not REPLACING is what protects it: `setWholeCart` empties every cart before copying
   * the stored ones back, so a foreign storage event would clear a cart that was never stored.
   *
   * ⚑ Nothing has to be emptied on page load any more, which is what this list used to be for
   * (`transientCarts`, 24.08.2026): a cart that is never stored starts empty by itself. That version
   * emptied inside `updateStore` — which is also the handler for storage events from OTHER tabs, so
   * every one of them wiped the running tab's price list (31.08.2026).
   *
   * Empty by default — a client that wants this names its carts in its own app.config.
   */
  tabLocalCarts: [] as string[],
})
